export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc'
}

export class PageRequest<T> {
  /**
   * Page number
   */
  page: number = 0

  /**
  * Page size
  */
  size: number

  /**
  * Query offset by sort
  */
  offset: number

  /**
   * Sort property
   */
  sort: string

  /**
   * Sort direction
   */
  sortOrder: SortDirection

  /**
   * Search text
   */
  search: string = ''

  /**
   * Custom filters object
   */
  filters: T

  constructor (size?: number, sort?: string, dir?: SortDirection) {
    this.size = size || 500
    this.sort = sort || ''
    this.offset = 0
    this.sortOrder = dir || SortDirection.ASC
    this.filters = {} as T
  }
}

export class PageResponse<T> {
  content: T[] = []
  results: T[] = []
  empty: boolean = true
  first: boolean = false
  last: boolean = false
  number: number = 0
  size: number = 0
  total: number = 0
  totalElements: number = 0
  totalPages: number = 0
}

export class InputSelectorData {
  text: string
  value: any

  constructor (text: string, value: any) {
    this.text = text
    this.value = value
  }
}

export class CursorRequest<T> {
  /**
  * Current page
  */
  currentPage = 1

  /**
  * Page size
  */
  limit: number

  /**
   * Next cursor for the next page
   */
  cursor: string

  /**
   * Total count
   */
  count: boolean

  /**
   * Custom filters object
   */
  filters: T

  constructor (limit: number = 50, count: boolean = false) {
    this.limit = limit
    this.count = count
    this.filters = {} as T
  }
}

export class CursorResponse<T> {
  results: T[] = []
  nextCursor = ''
  limit = 0
  size = 0
  total = 0
}
